import { logger } from "$lib/utils/logger";
import { recordTelemetryEvent } from "$lib/telemetry/telemetry";
import type { ContentApiResponse } from "./contentTypes";
import { CONTENT_CACHE_NAME, contentApiUrl } from "./contentApi";

// Last-known content per display, written by the service worker on every
// successful fetch, so a screen can paint instantly on a cold boot.
async function readCachedContent(
  displayId: string
): Promise<ContentApiResponse | undefined> {
  try {
    const cache = await caches.open(CONTENT_CACHE_NAME);
    const response = await cache.match(contentApiUrl(displayId));
    const content: ContentApiResponse | undefined = response
      ? await response.json()
      : undefined;
    const result = content ? "hit" : "miss";
    logger.info(`[ContentCache] Read: ${result}`);
    recordCacheMetric("read", result);
    return content;
  } catch (error) {
    logger.warn("[ContentCache] Read failed", error);
    recordCacheMetric("read", "error");
    return undefined;
  }
}

function recordCacheMetric(operation: "read", result: string): void {
  recordTelemetryEvent({
    name: "frontend_content_cache",
    metricType: "counter",
    value: 1,
    tags: { operation, result },
    omitDisplayId: true,
  });
}

export { readCachedContent };
